import { FaroDialog } from "@faro-lotv/flat-ui";
import { ReactNode, type JSX } from "react";

type ErrorDialogProps = {
  /** The title of the dialog */
  title: string | JSX.Element;

  /** The text appearing in the body of the dialog  */
  message: ReactNode;

  /** Callback notified when the dialog closes */
  onClose(): void;
};

/**
 * @returns A modal error dialog with custom title and message.
 */
export function AppErrorDialog({
  title,
  message,
  onClose,
}: ErrorDialogProps): JSX.Element {
  return (
    <FaroDialog
      open
      title={title}
      onClose={onClose}
      onConfirm={onClose}
      confirmText="Ok"
    >
      {message}
    </FaroDialog>
  );
}
